export default __webpack_public_path__ + "static/media/kpj-healthcare-logo.136b2845.png";